import * as React from "react";
import {
  MenuItem,
  FormControl,
  ListItemText,
  Checkbox,
  Typography,
  Stack,
  styled,
} from "@mui/material";
import Select from "@mui/material/Select";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 225,
      width: 250,
    },
  },
};

export interface SelectWithCheckboxInterface {
  placeholder: string;
  items: { value: string; label: string }[];
  value: string[];
  handleChange: (value: any) => void;
}

const SelectWithCheckbox = ({
  placeholder,
  items,
  value,
  handleChange,
}: SelectWithCheckboxInterface) => {
  const StyledCheckbox = styled(Checkbox)(() => ({
    padding: 0,
    "& .fas": {
      fontSize: 20,
    },
  }));

  return (
    <FormControl sx={{ width: "100%" }}>
      <Select
        multiple
        value={value}
        onChange={(e: any) => handleChange(e.target.value)}
        renderValue={() => {
          return placeholder;
        }}
        MenuProps={MenuProps}
        defaultValue={value}
        displayEmpty={true}
        style={{ borderRadius: "15px", fontSize: "14px", color: "#666" }}
      >
        {items.map((i) => (
          <MenuItem key={i.value} value={i.label}>
            <Stack direction="row" spacing={1}>
              <StyledCheckbox
                checked={value.indexOf(i.value) > -1}
                color="primary"
                // onClick={() => setSelectedFilters([...selectedFilters, filter])}
                checkedIcon={<i className="fas fa-check-square font-primary" />}
                icon={<i className="fas fa-square font-slate" />}
              />
              <ListItemText
                primary={
                  <Typography fontSize={20} fontWeight={500}>
                    {i.label}
                  </Typography>
                }
              />
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectWithCheckbox;
